import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  StatusCircle,
  StatusCircleItem,
  type StatusCircleToneProps,
} from '../../../../../styled-components/components/StatusCircle';
import Tooltip from '../../../../../styled-components/components/Tooltip';

const ns = 'salesAndPurchasingVehicles';

interface StatusCirclePresenterProps {
  count: number;
  status: string;
  tone?: StatusCircleToneProps;
}

const StatusCirclePresenter = ({ count, status, tone }: StatusCirclePresenterProps) => (
  <Tooltip tooltip={status}>
    <StatusCircleItem $tone={tone}>{count}</StatusCircleItem>
  </Tooltip>
);

interface TaskStatePresenterProps {
  completed: number;
  notStarted: number;
  inProgress: number;
  problem: number;
}

const TaskStatePresenter = memo(
  ({ completed, notStarted, inProgress, problem }: TaskStatePresenterProps) => {
    const { t } = useTranslation([ns, 'common']);

    return (
      <StatusCircle>
        <StatusCirclePresenter
          count={completed}
          status={t('taskStatePresenter.completed', { ns, count: completed })}
          tone="success"
        />
        <StatusCirclePresenter
          count={inProgress}
          status={t('taskStatePresenter.inProgress', { ns, count: inProgress })}
          tone="warning"
        />
        <StatusCirclePresenter
          count={notStarted}
          status={t('taskStatePresenter.notStarted', { ns, count: notStarted })}
        />
        <StatusCirclePresenter
          count={problem}
          status={t('taskStatePresenter.problem', { ns, count: problem })}
          tone="error"
        />
      </StatusCircle>
    );
  },
);

export default TaskStatePresenter;
